import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getEducationsLevels } from 'system-redux-sagas/actions';

type TUseEducationsLevel = {
  educationsLevel: { id: string; label: string }[];
  loadingEducationsLevel: boolean;
};

export const useEducationsLevel = (
  fetch: boolean = true,
): TUseEducationsLevel => {
  const lock = useRef<boolean>(false);
  const { educationsLevel, loadingEducationsLevel } = useSelector(
    (state: any) => state.system,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (!lock.current) {
      lock.current = true;
      fetch && dispatch(getEducationsLevels());
    }
  }, [dispatch, fetch]);

  return {
    educationsLevel,
    loadingEducationsLevel,
  };
};
